import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FadvComponentsModule,
  FadvStepperModule,
  FadvAlertModule,
  FadvApplicationModule,
  FadvBoxModule,
  FadvButtonModule,
  FadvCardModule,
  FadvGridModule,
  FadvLayoutModule,
  FadvTypographyModule,
  FadvCommonModule,
  FadvInputModule,
} from '@fa-switch-sharedservices/ng-elements';
import { PartnerRoutingModule } from './partner-routing.module';
import { PartnerComponent } from './partner.component';
import { PartnerStartComponent } from './partner-start/partner-start.component';
import { PartnerPackageComponent } from './partner-package/partner-package.component';
import { SharedModule } from '@app/shared/shared.module';
import { PartnerCandidateComponent } from './partner-candidate/partner-candidate.component';
import { PartnerAccountComponent } from './partner-account/partner-account.component';
import { PartnerPaymentComponent } from './partner-payment/partner-payment.component';
import { PartnerOnlineComponent } from './partner-online/partner-online.component';
import { PartnerInviteComponent } from './partner-invite/partner-invite.component';
import { PartnerCredentialingComponent } from './partner-credentialing/partner-credentialing.component';
import { SignupModule } from '@app/signup/signup.module';
import { PartnerContactComponent } from './partner-contact/partner-contact.component';
import { PartnerEmailComponent } from './partner-email/partner-email.component';
import { ErrorComponent } from './partner-error/partner-error.component';
import { AlertMessageModule } from '../alert-message/alert-message.module';



@NgModule({
  declarations: [PartnerComponent, PartnerStartComponent, PartnerPackageComponent, PartnerCandidateComponent, PartnerAccountComponent, PartnerPaymentComponent, PartnerOnlineComponent, PartnerInviteComponent, PartnerCredentialingComponent, PartnerContactComponent, PartnerEmailComponent, ErrorComponent],
  imports: [
    CommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FadvComponentsModule,
    FadvCardModule,
    FadvStepperModule,
    FadvCommonModule,
    FadvApplicationModule,
    FadvAlertModule,
    FadvLayoutModule,
    FadvGridModule,
    FadvInputModule,
    FadvButtonModule,
    FadvBoxModule,
    FadvTypographyModule,
    PartnerRoutingModule,
    SharedModule,
    SignupModule,
    AlertMessageModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class PartnerModule { }
